import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import QRCodeGeneratorPage from '../views/QRCodeGeneratorPage.vue'
import JSONConverterPage from '../views/JSONConverterPage.vue'
import PasswordGeneratorPage from '../views/PasswordGeneratorPage.vue'
import TimestampConverterPage from '../views/TimestampConverterPage.vue'
import Base64ConverterPage from '../views/Base64ConverterPage.vue'
import URLEncoderDecoderPage from '../views/URLEncoderDecoderPage.vue'
import HashGeneratorPage from '../views/HashGeneratorPage.vue'
import UUIDGeneratorPage from '../views/UUIDGeneratorPage.vue'
import CronGeneratorPage from '../views/CronGeneratorPage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/qrcode',
    name: 'QRCodeGenerator',
    component: QRCodeGeneratorPage
  },
  {
    path: '/json-converter',
    name: 'JSONConverter',
    component: JSONConverterPage
  },
  {
    path: '/password-generator',
    name: 'PasswordGenerator',
    component: PasswordGeneratorPage
  },
  {
    path: '/timestamp-converter',
    name: 'TimestampConverter',
    component: TimestampConverterPage
  },
  {
    path: '/base64-converter',
    name: 'Base64Converter',
    component: Base64ConverterPage
  },
  {
    path: '/url-encoder-decoder',
    name: 'URLEncoderDecoder',
    component: URLEncoderDecoderPage
  },
  {
    path: '/hash-generator',
    name: 'HashGenerator',
    component: HashGeneratorPage
  },
  {
    path: '/uuid-generator',
    name: 'UUIDGenerator',
    component: UUIDGeneratorPage
  },
  {
    path: '/cron-generator',
    name: 'CronGenerator',
    component: CronGeneratorPage
  },
  {
    path: '/cv',
    redirect: '/cv.html'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
